import React, { useEffect } from "react";
import AuthService from "../../../admin/components/login/AuthService";
import ApiService from "../../../admin/components/util/ApiService";

const LagoutClient = () => {
  useEffect(() => {
    // Função de logout
    const performLogout = async () => {
      try {
        // Chama o logout do AuthService
        AuthService.logout();


        // Obtém o domínio atual
        const currentDomain = window.location.hostname;

        // Redireciona com base no domínio
       window.location.href = "/login";

      } catch (error) {
        ApiService.handleApiError(error);
      }
    };


    performLogout();
  }, []);

  return null; // Não renderiza nada enquanto o logout está sendo processado
};

export default LagoutClient;
